import produce from 'immer';

export const actionTypes = {
    ClearUsers: 'CLEAR_USERS',
    DeleteUser: 'DELETE_USER',
    DeletedUser: 'DELETED_USER',
    FetchUser: 'FETCH_USER',
    FetchUserFailed: 'FETCH_USER_FAILED',
    FetchedUser: 'FETCHED_USER',
    RemoveUser: 'REMOVE_USER',
    UpdateUser: 'UPDATE_USER',
    UpdatedUser: 'UPDATED_USER',
    UpdateUserFailed: 'UPDATE_USER_FAILED',
};

const initialState = {
    loading: false,
    users: [],
    filtersContent: [],
    totalRecords: 0,
    user: null,
    error: null,
};

export function autoUserUserReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FetchUser: {
            return {
                ...state,
                loading: true,
                user: null,
                error: true,
            };
        }
        case actionTypes.FetchedUser: {
            return {
                ...state,
                loading: false,
                user: action.payload.user,
            };
        }
        // case actionTypes.ClearUsers:
        //   return {
        //     ...state
        //   }
        case actionTypes.ClearUsers:
            return produce(state, (draftState) => {
                draftState = {
                    ...draftState,
                    users: [],
                };
            });
        default:
            return state;
    }
}

export const actions = {
    fetchUser: () => ({ type: actionTypes.FetchUser }),
    clearUsers: () => ({ type: actionTypes.ClearUsers }),
    deleteUser: () => ({ type: actionTypes.DeleteUser }),
    deletedUser: () => ({ type: actionTypes.DeletedUser }),
    fetchedUser: (result) => ({ type: actionTypes.FetchedUser, payload: result }),
    fetchUserFailed: (error) => ({ type: actionTypes.FetchUserFailed, payload: error }),
    updateUser: () => ({ type: actionTypes.UpdateUser }),
    updatedUser: (result) => ({ type: actionTypes.UpdatedUser, payload: result }),
    updateUserFailed: (error) => ({ type: actionTypes.UpdateUserFailed, payload: error }),
};
